import { getAdditionalInformationByClaimGroupQuery } from './getAdditionalInformationByClaimGroupQuery';
import { getAdditionalInformationByClaimQuery } from './getAdditionalInformationByClaimQuery';
import getAdditionalInformationEntitiesSummaries from './getAdditionalInformationEntitiesSummaries';
import { getAdditionalInformationEntitiesSummariesAndTokenCommand } from './getAdditionalInformationEntitiesSummariesAndTokenCommand';
import getClaimDocument from './getClaimDocument';
import getClaimDocuments from './getClaimDocuments';
import { getClaimGroupConfirmationQuery } from './getClaimGroupConfirmationQuery';
import { getClaimGroupTransportPlanQuery } from './getClaimGroupTransportPlanQuery';
import getDefaultAddressForPickUpPointSearch from './getDefaultAddressForPickUpPointSearch';
import getFullClaimContextQuery from './getFullClaimContextQuery';
import { setClaimAdditionalInformationWithFilesCommand } from './setClaimAdditionalInformationWithFilesCommand';
import setClaimConfirmationCommand from './setClaimConfirmationCommand';
import { setClaimGroupAdditionalInformationCommand } from './setClaimGroupAdditionalInformationCommand';
import { setClaimGroupHandlingTransportPlanCommand } from './setClaimGroupHandlingTransportPlanCommand';
import { setClaimGroupReasonCommand } from './setClaimGroupReasonCommand';
import { setClaimGroupSolutionCommand } from './setClaimGroupSolutionCommand';
import uploadSharedFileCommand from './uploadSharedFileCommand';

export const CommonClaimService = {
  getAdditionalInformationEntitiesSummaries,
  getDefaultAddressForPickUpPointSearch,
  getClaimDocument,
  getClaimDocuments,
  uploadSharedFileCommand,
  setClaimGroupSolutionCommand,
  getFullClaimContextQuery,
  setClaimAdditionalInformationWithFilesCommand,
  getAdditionalInformationByClaimGroupQuery,
  getAdditionalInformationByClaimQuery,
  getAdditionalInformationEntitiesSummariesAndTokenCommand,
  getClaimGroupTransportPlanQuery,
  setClaimGroupHandlingTransportPlanCommand,
  setClaimConfirmationCommand,
  getClaimGroupConfirmationQuery,
  setClaimGroupReasonCommand,
  setClaimGroupAdditionalInformationCommand,
};
